import React from 'react';
import { FiX } from 'react-icons/fi';
import { LuBarChart3, LuSparkle } from 'react-icons/lu';
import { TEMPLATES } from './metricTreeTemplates';

/**
 * TemplateChooser — the "Not sure where to start?" onboarding card shown on an
 * empty canvas (Mixpanel parity). Offers the starter templates; picking one (or
 * "Build with AI") seeds the tree. AI generation is stubbed to the same seed for
 * now — onPick(key, { ai }) tells the canvas which path was taken.
 *
 * props: onPick(templateKey, { ai }), onClose()
 */
const ART = {
  kpi: (accent) => (
    <div style={{ height: 168, background: accent, display: 'grid', placeItems: 'center' }}>
      <LuBarChart3 size={62} color="#7A4B12" strokeWidth={1.6} />
    </div>
  ),
  northstar: (accent) => (
    <div style={{ height: 168, background: accent, display: 'grid', placeItems: 'center', position: 'relative', overflow: 'hidden' }}>
      {[0, 30, 60, 90, 120, 150].map((deg) => (
        <div key={deg} style={{
          position: 'absolute', width: '140%', height: 1, background: 'rgba(255,255,255,0.7)',
          transform: `rotate(${deg}deg)`,
        }}
        />
      ))}
      <LuSparkle size={54} color="#0F1A2B" strokeWidth={1.6} style={{ position: 'relative' }} />
    </div>
  ),
};

export default function TemplateChooser({ onPick, onClose }) {
  return (
    <div
      style={{
        position: 'absolute', top: 20, left: 20, zIndex: 7, width: 620, maxWidth: 'calc(100% - 40px)',
        background: '#fff', border: '1px solid #E3E9F1', borderRadius: 16,
        boxShadow: '0 2px 6px rgba(15,26,43,0.06), 0 20px 50px rgba(15,26,43,0.16)',
        padding: 24, fontFamily: '"Open Sans", system-ui, sans-serif',
      }}
    >
      <button
        type="button" aria-label="Dismiss" onClick={onClose}
        style={{
          position: 'absolute', top: 18, right: 18, border: 'none', background: 'transparent',
          cursor: 'pointer', color: '#64748B', padding: 4,
        }}
      >
        <FiX size={20} />
      </button>

      <div style={{ fontSize: 20, fontWeight: 800, color: '#0F1A2B' }}>Not sure where to start?</div>
      <div style={{ marginTop: 6, fontSize: 14, color: '#475569' }}>
        A template can help you map out an outline of your tree.
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginTop: 20 }}>
        {TEMPLATES.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => onPick(t.key)}
            style={{
              border: '1px solid #E3E9F1', borderRadius: 12, overflow: 'hidden',
              display: 'flex', flexDirection: 'column', padding: 0, cursor: 'pointer',
              background: '#fff', textAlign: 'left',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#4f5ed1'; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#E3E9F1'; }}
          >
            {ART[t.key](t.accent)}
            <div style={{ padding: '14px 16px' }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: '#0F1A2B' }}>{t.title}</div>
              <div style={{ marginTop: 6, fontSize: 13, color: '#64748B', lineHeight: 1.45 }}>{t.blurb}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
